// extracted by mini-css-extract-plugin
export var navLinks = "mainVerticalMenu-module--nav-links--uCJW0";
export var mouseIconLink = "mainVerticalMenu-module--mouse-icon-link--iFIFa";